const menu = {
    single_sign_on: 'Jednokrotne logowanie',
    profile: 'Profil',
    language: 'Język',
    appearance: {
        label: 'Wygląd',
        light: 'Tryb jasny',
        dark: 'Tryb ciemny',
        system: 'Synchronizuj z systemem',
    },
    sign_out: 'Wyloguj się',
};
export default Object.freeze(menu);
